import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";

import Layout from "./pages/layout";
import LayoutEasyMaps from "./pages/layoutEasymaps";
import LayoutEasyMapsPublic from "./pages/layoutEasymapsPublic";
import Construcao from "./pages/construcao";
import Login from "./pages/login";
import Perfil from "./pages/perfil";
import HomeIn from "./pages/homeIn";

//import Acessos from "./pages/Acessos";
import Suporte from "./pages/suporte";
import Chat from "./pages/suporte/chat";
import RelatoriosFlow from "./pages/easyFlow/relatoriosFlow";
import EasyFlow from "./pages/easyFlow";
import Administracao from "./pages/configuracoes/administracao";
import Cadastro from "./pages/cadastro";

import EasyMaps from "./pages/easyMaps";
import EasyMapsOld from "./pages/easymapsOld";
import EasyReport from "./pages/easyReportOld";
import EasyAdd from "./pages/easyAdd";

import SolicitarRedefinirSenha from "./pages/solicitarRedefinirSenha";
import RedefinirSenha from "./pages/redefinirSenha";
import AgendarRelatorio from "./pages/easyReportOld/agendarRelatorio";
import SelectionPage from "./pages/easyReportOld/selectionPage";
import NovoRelatorio from "./pages/easyReportOld/agendarRelatorio/novoRelatorio";
import HistoricoRelatorio from "./pages/easyReportOld/agendarRelatorio/historicoRelatorio";
import GerarRelatorio from "./pages/easyReportOld/gerarRelatorio";
import MapaGeolocalizado from "./pages/easyMaps/maps/geolocalizado";
import MapaTopologia from "./pages/easyMaps/maps/topologia";
import { socket, socketCliente } from "./services/socket";

// import NovoRelatorio from "./pages/easyReport/relatorios/novoRelatorio";
import MapaGeolocalizadoPublic from "./pages/easyMaps/maps/geolocalizadoPublic";
import MapaTopologiaPublic from "./pages/easyMaps/maps/topologiaPublic";
import NotFoundMaps from "./pages/easyMaps/pages/notFound";
import GruposEasyMaps from "./pages/easyMaps/pages/grupos";
import MapasGeolocalizadosEasyMaps from "./pages/easyMaps/pages/geolocalizado";
import MapaTopologiaEasyMaps from "./pages/easyMaps/pages/topologia";
import MapaTopologiaPOPEasyMaps from "./pages/easyMaps/pages/pop";
import MapaGeolocalizadoERP from "./pages/easyMaps/maps/geolocalizadoFTTH";
import ProtectedRoute from "./pages/protectedRoute";
import ScriptsOnus from "./pages/scriptsOnus";
import EasyLog from "./pages/easyLog";
import { HistoricoEasyLog } from "./pages/easyLog/pages/historico";
import { InsightsEasyLog } from "./pages/easyLog/pages/Insights";
import Configuracoes from "./pages/configuracoes";
import EasyLogConfig from "./pages/configuracoes/easyLogs";
import AccountType from "./pages/cadastro/accountType";
import EasyReportConfig from "./pages/configuracoes/easyReport";
import checkAuthenticated from "./pages/protectedRoute/loaderFunction";

const routers = ({
  socket,
  socketCliente,
  setCheckLogin,
  checkLogin,
  setColorMode,
  colorMode,
}) => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route
          path="/login"
          element={<Login setCheckLogin={setCheckLogin} />}
        />
        <Route path="/accountType" element={<AccountType />} />
        <Route path="/resetPassword/:token/:id" element={<RedefinirSenha />} />
        <Route path="/resetPassword" element={<SolicitarRedefinirSenha />} />
        <Route path="*" element={<Navigate replace to="/login" />} />
        <Route path="/cadastro" element={<Cadastro />} />

        {/* Rotas protegidas */}

        {/* Rotas públicas do EasyMaps */}
        <Route
          element={
            <LayoutEasyMapsPublic
              colorMode={colorMode}
              setColorMode={setColorMode}
            />
          }
        >
          <Route
            path="/easyMaps/*"
            element={<Navigate replace to="/easyMaps/pages/notFound" />}
          />
          <Route path="/easyMaps/pages/notFound" element={<NotFoundMaps />} />
          <Route
            path="/easyMaps/mapa/public/geo/:id/:token"
            element={<MapaGeolocalizadoPublic socketCliente={socketCliente} />}
          />
          <Route
            path="/easyMaps/mapa/public/top/:id/:token"
            element={<MapaTopologiaPublic socketCliente={socketCliente} />}
          />
          <Route
            path="/easyMaps/mapa/public/rp/:id/:token"
            element={
              <MapaGeolocalizadoERP
                isPublic={true}
                socketCliente={socketCliente}
              />
            }
          />
        </Route>

        {/* Rotas principais */}
        <Route
          loader={() => checkAuthenticated(setCheckLogin)}
          fall
          shouldRevalidate={({ currentUrl, nextUrl }) =>
            currentUrl.pathname !== nextUrl.pathname
          }
        >
          <Route
            element={
              <Layout
                socket={socket}
                socketCliente={socketCliente}
                colorMode={colorMode}
                setColorMode={setColorMode}
              />
            }
          >
            <Route path="/homeIn" element={<HomeIn />} />
            <Route
              path="/configuracoes"
              element={<Navigate replace to="/configuracoes/administracao" />}
            />
            <Route element={<Configuracoes />}>
              <Route
                path="/configuracoes/administracao"
                element={<Administracao />}
              />
              <Route
                path="/configuracoes/easyLogs"
                element={<EasyLogConfig />}
              />
              <Route
                path="/configuracoes/easyReport"
                element={<EasyReportConfig />}
              />
            </Route>
            <Route path="/perfil" element={<Perfil />} />

            {/* Rotas do EasyLog */}
            <Route
              path="/easyLog"
              element={<Navigate replace to="/easyLog/historico" />}
            />
            <Route
              path="/easyLog/*"
              element={<Navigate replace to="/easyLog/historico" />}
            />
            <Route element={<EasyLog />}>
              <Route path="/easyLog/historico" element={<HistoricoEasyLog />} />
              <Route path="/easyLog/insights" element={<InsightsEasyLog />} />
            </Route>

            <Route
              path="/easyAdd"
              element={<EasyAdd socket={socketCliente} />}
            />
            <Route path="/scriptONUs" element={<ScriptsOnus />} />

            {/* Rotas do EasyReport */}
            <Route path="/easyReport" element={<EasyReport />}>
              <Route
                path="/easyReport/*"
                element={<Navigate replace to="/easyReport/selecionarPagina" />}
              />
              <Route
                path="/easyReport/selecionarPagina"
                element={<SelectionPage />}
              />
              <Route
                path="/easyReport/agendar"
                element={<AgendarRelatorio />}
              />
              <Route path="/easyReport/gerar" element={<GerarRelatorio />} />
              <Route
                path="/easyReport/agendar/novoRelatorio"
                element={<NovoRelatorio />}
              />
              <Route
                path="/easyReport/agendar/historico/:relatorioId"
                element={<HistoricoRelatorio />}
              />
            </Route>

            <Route path="/easySGP" element={<Construcao />} />
            <Route path="/suporte" element={<Suporte socket={socket} />}>
              <Route path="/suporte/:chatId" element={<Chat />} />
            </Route>
            <Route path="/documentacao" element={<Construcao />} />
            <Route path="/easyFlow" element={<EasyFlow />}>
              <Route
                path="/easyFlow/relatoriosFlow"
                element={<RelatoriosFlow />}
              />
            </Route>
          </Route>

          <Route
            element={
              <LayoutEasyMaps
                socket={socket}
                socketCliente={socketCliente}
                colorMode={colorMode}
                setColorMode={setColorMode}
                setCheckLogin={setCheckLogin}
              />
            }
          >
            <Route
              path="/easyMaps"
              element={<Navigate replace to="/easyMaps/grupos" />}
            />
            <Route
              path="/easyMaps/*"
              element={<Navigate replace to="/easyMaps/grupos" />}
            />
            <Route path="/easyMaps/pages/notFound" element={<NotFoundMaps />} />

            <Route element={<EasyMaps />}>
              <Route path="/easyMaps/grupos" element={<GruposEasyMaps />} />
              <Route
                path="/easyMaps/mapas/geolocalizado"
                element={<MapasGeolocalizadosEasyMaps />}
              />
              <Route
                path="/easyMaps/mapas/topologia"
                element={<MapaTopologiaEasyMaps />}
              />
              <Route
                path="/easyMaps/mapas/pop"
                element={<MapaTopologiaPOPEasyMaps />}
              />
            </Route>

            <Route
              path="/easyMaps/mapa/rp/:id"
              element={<MapaGeolocalizadoERP socketCliente={socketCliente} />}
            />
            <Route
              path="/easyMaps/mapa/geo/:id"
              element={<MapaGeolocalizado socketCliente={socketCliente} />}
            />
            <Route
              path="/easyMaps/mapa/top/:id"
              element={<MapaTopologia socketCliente={socketCliente} />}
            />
          </Route>
        </Route>
      </Route>
    )
  );
};

export default routers;
